export default __webpack_public_path__ + "static/media/Heaven's Jang Ssang Gum.5d0013f7.jpg";